<script lang="ts">
	import DashSelectList from '../Components/DashSelectList.svelte';
	import type { DashWidgetEditType, ListRefType } from '../../dash-types';

	export let allTypeRefs: ListRefType;
	export let editItem: DashWidgetEditType;
</script>

<DashSelectList bind:editItem bind:allCardsRefs={allTypeRefs} />
